import React, { useContext } from 'react'

import { useRequest } from '../hooks/request'
import { UserContext } from '../data/UserContext'
import { profileEdit, profileEditPath } from '../requests/profile'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { UserForm } from './UserForm'

const disabledFields = {
  firstName: true,
  lastName: true,
  email: true,
  unit: true,
  role: true,
}

const onCancel = (form) => () => form.reset()
export const Profile = () => {
  const { user, setUser } = useContext(UserContext)
  const profileEditRequest = useRequest({
    request: profileEdit,
    handler: (p) => p.then((newUser) => {
      setUser(newUser)
    }),
  })

  return (
    <>
      <PageTitle tradId="profile" />
      <PageContent>
        <UserForm
          disabledFields={disabledFields}
          cancelLabel="cancelModifications"
          confirmLabel="saveModifications"
          initialValues={user}
          path={profileEditPath}
          showChangeEmail
          successMessage="saveModificationsSuccess"
          onSubmit={profileEditRequest.fetch}
          onCancel={onCancel}
        />
      </PageContent>
    </>
  )
}
